// extracted by mini-css-extract-plugin
export default {"container":"Services_container__8TNfr","buttonContainer":"Services_buttonContainer__1LBfL"};